import { Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { FormItemCommonProps, nameWithPrefix } from '.';
import { lastNameRule } from '../rules';

export const LastNameFormItem = ({ keyPrefix, disabled }: FormItemCommonProps) => {
  const { t } = useTranslation();

  return (
    <Form.Item
      label={t('Last name')}
      name={nameWithPrefix({ name: 'lastName', keyPrefix })}
      rules={[lastNameRule()]}
    >
      <Input disabled={disabled} />
    </Form.Item>
  );
};
